module.exports = __webpack_public_path__ + "static/media/top_phone.f6d5cc34.png";